module.exports = __webpack_public_path__ + "img/mall-active.499da250.png";